export default __webpack_public_path__ + "static/sample-size-determination-light-c7adba635c01940d8383e2596d59c065.png";